import React from "react";

const PopupContext = React.createContext({
  toggle: () => null,
});

export default PopupContext;
